import ClearingAPI from '@shared/api';

export const {
    accounts: { putById: putAccount, getAccountStatement, getTaxForm },
    verificationResult: { get: getVerificationResults },
} = ClearingAPI.settings;
